const MAX_REDIRECT_LENGTH = 512;
const FIRST_PRINTABLE_CHAR_CODE = 32;

function hasControlCharacter(value: string): boolean {
  for (let index = 0; index < value.length; index += 1) {
    if (value.charCodeAt(index) < FIRST_PRINTABLE_CHAR_CODE) return true;
  }
  return false;
}

/**
 * Accepts only same-site absolute paths ("/checkout/x?y=1"). Anything that could leave the site —
 * "//evil.com", "/\\evil.com", "https://…", control characters — falls back. Used by the server
 * before redirecting after login and by the client before building the login link.
 */
export function toSafeRedirectPath(candidate: string | null | undefined, fallback: string): string {
  if (!candidate || candidate.length > MAX_REDIRECT_LENGTH) return fallback;
  if (!candidate.startsWith("/")) return fallback;
  if (candidate.startsWith("//") || candidate.startsWith("/\\")) return fallback;
  if (candidate.includes("\\") || hasControlCharacter(candidate)) return fallback;
  if (candidate.startsWith("/api/")) return fallback;
  return candidate;
}
